import type { GameFragment, SelectedProvider } from "../../../types";

const filterGamesByProviders = (
  games: GameFragment[],
  providerFilter: SelectedProvider[],
): GameFragment[] => {
  // If no filter provider, returns the entire list
  if (!providerFilter.length) return games;

  return games.filter((item) => {
    const providerName = item.menuItem?.[0]?.name || item.menuItem?.[0]?.handle;

    return (
      Boolean(providerName) &&
      providerFilter.some(
        (provider) =>
          providerName &&
          provider.name?.toLowerCase() === providerName.toLowerCase(),
      )
    );
  });
};

export default filterGamesByProviders;
